import {createStore,applyMiddleware} from 'redux'
import {powerQueryReducer} from './Reducers/PowerQuery';

import middleware from './middleware'
import { Store } from 'redux';

// export default createStore(powerQueryReducer, applyMiddleware(...middleware))
const store: Store = createStore(powerQueryReducer, applyMiddleware(...middleware));

export default store;